// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import { routerBeforeEach } from './router/before_each'
import pubFun from './common/function'
import rootHttpClient from '@/http/interceptors'
import API from './utils/sha256/myHttpClient'
import axios from 'axios'
import store from './store/storeAll'
import ElementUI from 'element-ui'
import './assets/css/reset.css'
import 'element-ui/lib/theme-chalk/index.css'
import './components/index'
import toolFunction from './utils/toolFunction'
import systemInfo from './utils/systemInfo'
// 多语言
import Trans from './utils/trans/index'
import './utils/index'
import * as filters from './filters' // global filters
//浏览器右键插件
import Contextmenu from "vue-contextmenujs"
import OidcServer from '@/oidcServices/OidcServer'
Vue.use(Contextmenu)
sessionStorage.setItem('nowFrameIndex', 0)
// 获取语言
function getLangByKey(key) {
  return key
}
Vue.use(ElementUI)
Vue.config.productionTip = false
Vue.prototype.$systemInfo = systemInfo
Vue.prototype.$pub_fun = pubFun
Vue.prototype.$API = axios
Vue.prototype.$Client = API
Vue.prototype.$toolFunction = toolFunction
Vue.prototype.$nt = getLangByKey
Vue.prototype.$tt = getLangByKey
Vue.prototype.$trans = Trans
Vue.prototype.$rootHttpClient = rootHttpClient
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
const url = location.origin + '/serverConfig.json'
routerBeforeEach()
systemInfo.initUrlInfo()
axios.get(url).then(e => {
  window.PROXY_URL_CONFIG = e.data || {}
  systemInfo.setServerConfig(JSON.stringify(window.PROXY_URL_CONFIG))
  // 设置租户信息: 1 url上带的 2 配置文件里面返回回来的default_tenant 3.默认的huansi租户
  const paramsStr = location.href.split('?')[1]
 // const paramsStrResult = toolFunction.transferUrlQueryStrToObj(paramsStr)
  if (location.pathname !== '/signout-oidc') { // 必须要加这个判断否则会清除原有的租户信息
    const session_tenant = systemInfo.getTenant();
    if(!session_tenant){
      systemInfo.setTenant(window.PROXY_URL_CONFIG.default_tenant)
    }
  }
  // 初始化oidc
  window.mgr = new OidcServer(handleOidcConfig())
  window.$_vue = new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>',
    beforeCreate() { }
  })
})
function handleOidcConfig() {
  const oidc_config = {}
  if (window.PROXY_URL_CONFIG.oidc_authority) oidc_config.authority = window.PROXY_URL_CONFIG.oidc_authority
  if (window.PROXY_URL_CONFIG.oidc_client_id) oidc_config.client_id = window.PROXY_URL_CONFIG.oidc_client_id
  console.log(oidc_config)
  return oidc_config
}



// WEBPACK FOOTER //
// ./src/main.js